enum RepairType {
  Windshield = 1,
  VehicleDamage = 2,
  HailDamage = 3,
}

export default RepairType;